import { SagaIterator } from '@redux-saga/core';
import { Institution } from '@tempus/trials-types';
import { call, put, select, takeLatest, takeLeading } from 'redux-saga/effects';

import api from '~/store/api';
import { creators as notificationCreators } from '~/store/notification';

import { creators } from './actions';
import {
  GetAllSitesFailedAction,
  GetUserSitesFailedAction,
  GET_ALL_SITES,
  GET_ALL_SITES_FAILED,
  GET_USER_SITES,
  GET_USER_SITES_FAILED,
  UserSiteMap,
} from './types';

function* fetchAllSites(): SagaIterator {
  const timeSites: Institution[] = yield select(({ site }) => site.timeSites);

  if (timeSites.length) {
    return;
  }

  try {
    const { data } = yield call(api.timeSites.getAll);
    yield put(creators.setAllSites(data.data));
  } catch (error) {
    if (error instanceof Error) {
      yield put(creators.getAllSitesFailed(error.message));
    }
  }
}

export function* fetchUserSites(): SagaIterator {
  let userSites: UserSiteMap | null = yield select(({ site }) => site.userSites);

  try {
    if (!userSites) {
      userSites = yield call(api.timeSites.getUserSites);
    }

    yield put(creators.setUserSites(userSites, null));
  } catch (error) {
    const failure = error instanceof Error ? error : new Error('Failed to fetch user sites');
    yield put(creators.getUserSitesFailed(failure));
  }
}

function* putErrorMessage({ error }: GetUserSitesFailedAction | GetAllSitesFailedAction): SagaIterator {
  yield put(notificationCreators.showErrorMessage(typeof error === 'string' ? error : error.message));
}

export default [
  takeLeading(GET_ALL_SITES, fetchAllSites),
  takeLatest(GET_ALL_SITES_FAILED, putErrorMessage),
  takeLeading(GET_USER_SITES, fetchUserSites),
  takeLatest(GET_USER_SITES_FAILED, putErrorMessage),
];
